
import Hero from "@/components/Hero";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, Heart, LightbulbOff, Brain, MessageSquareHeart } from "lucide-react";

const Coaching = () => {
  return (
    <div className="fade-in">
      <Hero 
        title="Coaching"
        subtitle="Valik Coachingu teele asuda on võimas samm isikliku ja professionaalse kasvu suunas."
        bgColor="bg-gradient-to-r from-kaija-sage to-kaija-light"
      />
      
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            <div className="w-20 h-1 bg-kaija-slate rounded-full mx-auto mb-10"></div>

            <h2 className="text-2xl font-medium mb-6 text-center">Miks valida minu coaching?</h2>
            <p className="text-gray-700 mb-6">
              Minu lähenemine läheb sügavamale kui tavapärane coaching. Ühendan oma töös somaatilise traumateadliku lähenemise, positiivse psühholoogia ning hüpnoteraapia tööriistad, et toetada sind nii mineviku mõistmises, oleviku kogemises kui ka teadliku tuleviku loomises.
            </p>
            
            <p className="text-gray-700 mb-6">
              Meie minevikukogemused – eriti traumaatilised – võivad salvestuda kehas ja mõjutada meie igapäevaelu, suhteid, enesetunnet ja valikuid, sageli alateadlikul tasandil. Just seetõttu ei piisa sageli vaid loogilistest sammudest ja eesmärkide seadmisest. Vajame terviklikku lähenemist, mis toetab keha ja meele koostööd ning aitab sul leida sügavam tasakaal.
            </p>
            
            <p className="text-gray-700 mb-6">
              Coaching'u käigus loon turvalise ja hinnangutevaba ruumi, kus saad olla sina ise, uurida oma tundeid ja mustreid, mõtestada oma kogemusi ning liikuda enda jaoks olulises suunas – olgu selleks parem enesetunne, sisemine rahu, isiklik kasv või elu, mis päriselt kõnetab.
            </p>
            
            <p className="text-gray-700 mb-10">
              Coaching ei ole ainult väljakutsete ületamine. See on teadlikkuse kasvatamine, tervenemine ja sisemise potentsiaali avamine. Olen siin, et toetada sind sellel teekonnal.
            </p>
            
            <h2 className="text-2xl font-medium mb-6 text-center">Minu meetodid</h2>
            <div className="w-16 h-1 bg-kaija-slate/60 rounded-full mx-auto mb-6"></div>
            <p className="text-gray-700 mb-8">
              Minu töös põimuvad somaatiline enesejuhtimine, traumateadlikkus, positiivne psühholoogia ja hüpnoteraapia. Usun, et keha, meel ja närvisüsteem on sügavalt seotud – ja seetõttu tuleb tõelise ja püsiva muutuse saavutamiseks toetada neid ühiselt.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
              <div className="bg-gradient-to-br from-kaija-sage to-kaija-light p-6 rounded-lg shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="bg-white p-2 rounded-full shadow-sm mr-3">
                    <Brain className="h-6 w-6 text-kaija-slate" />
                  </div>
                  <h3 className="text-lg font-medium">Somaatiline praktika</h3>
                </div>
                <p className="text-gray-700">
                  Toetun keha ja meele vahelistele seostele, et aidata sul teadlikkust tuua kehasse salvestunud emotsionaalsete mustrite kohta. Läbi kehalise tunnetuse õpid paremini märkama, mis sind mõjutab ja kuidas end turvaliselt reguleerida.
                </p>
              </div>
              
              <div className="bg-gradient-to-br from-kaija-sage to-kaija-light p-6 rounded-lg shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="bg-white p-2 rounded-full shadow-sm mr-3">
                    <Heart className="h-6 w-6 text-kaija-slate" />
                  </div>
                  <h3 className="text-lg font-medium">Traumateadlikkus</h3>
                </div>
                <p className="text-gray-700">
                  Aitan sul mõista, kuidas varasemad kogemused võivad mõjutada sinu praeguseid reaktsioone ja uskumusi. Toetame su närvisüsteemi ning liigume samm-sammult tervenemise ja sisemise vabaduse suunas.
                </p>
              </div>
              
              <div className="bg-gradient-to-br from-kaija-sage to-kaija-light p-6 rounded-lg shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="bg-white p-2 rounded-full shadow-sm mr-3">
                    <MessageSquareHeart className="h-6 w-6 text-kaija-slate" />
                  </div>
                  <h3 className="text-lg font-medium">Positiivne psühholoogia</h3>
                </div>
                <p className="text-gray-700">
                  Toetan sind sisemiste tugevuste äratundmisel, eesmärkide seadmises ning tähendusliku elu loomises. See aitab sul mitte ainult taastuda, vaid ka kasvada ja luua elu, mida soovid – mitte seda, mida lihtsalt talud.
                </p>
              </div>
              
              <div className="bg-gradient-to-br from-kaija-sage to-kaija-light p-6 rounded-lg shadow-sm">
                <div className="flex items-center mb-4">
                  <div className="bg-white p-2 rounded-full shadow-sm mr-3">
                    <LightbulbOff className="h-6 w-6 text-kaija-slate" />
                  </div>
                  <h3 className="text-lg font-medium">Hüpnoteraapia</h3>
                </div>
                <p className="text-gray-700">
                  Sügavam vaade sinu alateadvusesse aitab vabastada blokeeringuid, muuta alateadlikke uskumusi ja toetada positiivseid nihkeid su sisemises maailmas ning igapäevaelus.
                </p>
              </div>
            </div>
            
            <p className="text-gray-700 mb-10">
              Kõik need meetodid toetavad sind terviklikult – mitte ainult sümptomite vähendamisel, vaid ka sisemise muutuse ja pikaajalise tasakaalu saavutamisel. Sinu lugu, kogemused ja eesmärgid on olulised. Olen siin, et kuulata, mõista ja koos sinuga ehitada elu, mis tundub päriselt sinu oma.
            </p>
            
            <div className="flex justify-center">
              <Button asChild className="bg-kaija-slate hover:bg-opacity-90 text-white">
                <Link to="/somatic-coaching" className="flex items-center">
                  Tutvu coaching pakettidega <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-kaija-light to-kaija-sage/70 text-center">
        <div className="container-custom">
          <h2 className="text-2xl md:text-3xl font-medium mb-6">Alusta enda teekonda</h2>
          <p className="text-gray-700 mb-8 max-w-2xl mx-auto text-lg">
            Võta täna ühendust ja sisene transformatsiooni ja isikliku arengu maailma.
          </p>
          <Button asChild className="bg-kaija-slate hover:bg-opacity-90 text-white px-8 py-6 text-lg group transition-all duration-300">
            <Link to="/contact" className="flex items-center">
              Võta ühendust <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>
        </div>
      </section>
    </div>
  );
};

export default Coaching;
